import { AdminTopBarContent } from "./admin-top-bar.content";

export const AdminTopBar = () => {
  return <AdminTopBarContent />;
};
